var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon-chart",on:{"click":function($event){return _vm.getMenu(_vm.id)}}},[_c('use',{attrs:{"xlink:href":"#icon-chart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }